import { gql } from "@apollo/client";

export const SIGN_UP = gql`
  mutation ($input: SignupInput!) {
    signup(input: $input) {
      ... on TokenResponseType {
        token
      }

      ... on ErrorType {
        field
        messages
      }
    }
  }
`;

export const SIGN_IN = gql`
  mutation ($email: String!, $password: String!) {
    signin(email: $email, password: $password) {
      ... on TokenResponseType {
        token
      }

      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }
    }
  }
`;

export const SOCIAL_SIGN_IN = gql`
  mutation ($input: SocialSigninInput!) {
    socialSignin(input: $input) {
      ... on TokenResponseType {
        token
      }

      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }
    }
  }
`;

export const UPDATE_PROFILE = gql`
  mutation ($input: UpdateProfileInput!) {
    updateProfile(input: $input) {
      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }

      ... on ProfileType {
        id
        firstName
        lastName
        email
        PhoneAreaCode
        PhoneNumber
        isStaff
        isActive
        dateJoined
        avatar
        currency
        lastLogin
        gender
        birthDate
        country
        city
      }
    }
  }
`;

export const PARTIAL_UPDATE_PROFILE = gql`
  mutation PartialUpdateProfile($input: PartialUpdateProfileInput!) {
    partialUpdateProfile(input: $input) {
      ErrorCode
      ErrorReason
    }
  }
`;

export const UPDATE_PREFERRED_LANGUAGE = gql`
  mutation UpdatePreferredLanguage($input: PartialUpdateProfileInput!) {
    partialUpdateProfile(input: $input) {
      ErrorCode
      ErrorReason
    }
  }
`;
